/**
 * Component to synchronize theme preferences between next-themes and Supabase
 * Should be rendered inside ThemeProvider
 */

import { useThemeSync } from '@/hooks/use-theme-sync';

export const ThemeSync = () => {
  useThemeSync();
  return null;
};
